import http from '../utils/http'

var TRACKING_BASE = '/api/v1/data/platform/events'
var QUEUE_KEY = 'gc_tracking_queue'
var FLUSH_INTERVAL = 5000      // 定时批量上报间隔
var BATCH_SIZE = 20            // 单次批量条数上限
var MAX_QUEUE = 200            // 队列上限，避免占满 localStorage

/** 从 localStorage 恢复未上报的队列 */
function loadQueue() {
  try {
    var raw = localStorage.getItem(QUEUE_KEY)
    return raw ? JSON.parse(raw) : []
  } catch (e) { return [] }
}

function persistQueue(q) {
  try {
    if (q.length === 0) localStorage.removeItem(QUEUE_KEY)
    else localStorage.setItem(QUEUE_KEY, JSON.stringify(q))
  } catch (e) {}
}

var queue = loadQueue()
var flushing = false

function normalize(event) {
  return {
    eventName: event.eventName,
    gameId: event.gameId || null,
    userId: event.userId,
    source: event.source || '',
    pageName: event.pageName || '',
    isNew: event.isNew || 0,
    eventData: event.eventData || {},
    ts: Date.now()
  }
}

/** 入队；单条上报 API 保留兼容名 */
export function reportEvent(event) {
  if (!event || !event.eventName || !event.userId) {
    return Promise.reject(new Error('eventName 和 userId 为必填'))
  }
  queue.push(normalize(event))
  if (queue.length > MAX_QUEUE) queue = queue.slice(-MAX_QUEUE)
  persistQueue(queue)
  return Promise.resolve()
}

/** 立即批量上报一次（后台调用） */
export function flushTracking() {
  if (flushing || queue.length === 0) return Promise.resolve()
  flushing = true
  var batch = queue.slice(0, BATCH_SIZE)
  // 后端未支持 batch 时，退化为多次单条上报
  var reqs = batch.map(function(ev) {
    return http.post(TRACKING_BASE, ev).catch(function() { return null })
  })
  return Promise.all(reqs).then(function() {
    queue = queue.slice(batch.length)
    persistQueue(queue)
    flushing = false
    // 队列还有剩余，继续尝试
    if (queue.length > 0) setTimeout(flushTracking, 300)
  }).catch(function() {
    flushing = false
  })
}

/** 页面即将卸载时用 sendBeacon 兜底，避免丢事件 */
function flushWithBeacon() {
  if (!queue.length) return
  if (typeof navigator === 'undefined' || !navigator.sendBeacon) return
  try {
    queue.forEach(function(ev) {
      var blob = new Blob([JSON.stringify(ev)], { type: 'application/json' })
      navigator.sendBeacon(TRACKING_BASE, blob)
    })
    queue = []
    persistQueue(queue)
  } catch (e) {}
}

// 定时批量上报
if (typeof window !== 'undefined') {
  setInterval(function() { flushTracking() }, FLUSH_INTERVAL)
  // 页面隐藏/卸载时兜底
  window.addEventListener('pagehide', flushWithBeacon)
  window.addEventListener('beforeunload', flushWithBeacon)
  document.addEventListener('visibilitychange', function() {
    if (document.hidden) flushWithBeacon()
  })
  // 恢复在线时立刻尝试刷一次
  window.addEventListener('online', function() { flushTracking() })
}
